import { useEffect } from "react";

const DEFAULTS = {
  title: "#BlackGirlJoyChallenge Winner Toolkit | Southern Black Girls",
  description: "Make your winner frame, create your shareable page, and get a personal press release. An initiative of Southern Black Girls and Women's Consortium, in partnership with the Pete & Thomas Foundation.",
  image: "",
  type: "website",
};

function setTag(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!value) { el?.remove(); return; }
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
}

export function applyMeta({ title, description, image, url, type } = {}) {
  const t = title || DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image ?? DEFAULTS.image;
  document.title = t;
  setTag("name", "description", d);
  setTag("property", "og:title", t);
  setTag("property", "og:description", d);
  setTag("property", "og:image", img);
  setTag("property", "og:url", url || window.location.href);
  setTag("property", "og:type", type || DEFAULTS.type);
  setTag("name", "twitter:card", img ? "summary_large_image" : "summary");
  setTag("name", "twitter:title", t);
  setTag("name", "twitter:description", d);
  setTag("name", "twitter:image", img);
}

export function usePageMeta(meta, deps = []) {
  useEffect(() => {
    applyMeta(meta);
    return () => applyMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
